<template>
  <div style="overflow-x: hidden;">
    <el-container>
      <el-header style="height: auto;">
        <Top/>
        <div class="promotion">
          <div>{{ $t('index.freeDeliveryBar') }}</div>
        </div>
      </el-header>
      <el-main :style="{minHeight:$store.state.minHeight}">
        <router-view :key="$route.fullPath"/>
      </el-main>
      <el-footer style="height: auto;">
        <Footer></Footer>
      </el-footer>
    </el-container>
    <Login/>
    <Register/>
    <Forgotpass/>
    <ShopCartBox/>
  </div>
</template>

<script>
import Top from '@/common/Top.vue';
import Footer from '@/common/Footer.vue';
import Login from '@/common/Login.vue';
import Register from '@/common/Register.vue';
import Forgotpass from '@/common/ForgotPass.vue';
import ShopCartBox from '@/common/ShopCartBox.vue';

export default {
  components: {
    Top,
    Footer,
    Login,
    Register,
    Forgotpass,
    ShopCartBox,
  },
  data () {
    return {};
  },
  mounted () {
    var that = this;
    window.addEventListener('resize', () => {
      var val = $(document.body).width() >= 992 ? true : false;
      that.$store.commit('setIsPC', val);
      that.$store.commit('setMinHeight', ($(window).height() - 140) + 'px');
      document.body.style.overflow = '';
    });
  },
  methods: {},

};
</script>
<style scoped>
.el-header, .el-main, .el-footer {
  margin  : 0;
  padding : 0;
}

.el-main {
  width      : 100%;
  /* max-width: 1600px; */
  margin     : auto;
  overflow-x : hidden;
}

.promotion {
  display         : flex;
  justify-content : space-around;
  flex-wrap       : wrap;
  background      : #F0F0F0;
  color           : #68B6F5;
  font-weight     : 600;
}

.promotion > div {
  /* text-align: center; */
  padding : 5px 0;
}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue